<template>
  <el-form-item v-tenant :label="isLabel ? '项目名称：' : ''" prop="corp_id">
    <el-select v-model="selected" filterable :clearable="tenantSelClear" placeholder="请选择" :size="size" :style="`width: ${$selectWidth};`" @change="change">
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.name"
        :value="typeof(value)==='string'?item.id.toString():item.id"
      />
    </el-select>
  </el-form-item>

</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    size: {
      type: String,
      default: 'small'
    },
    isLabel: {
      type: Boolean,
      default: true
    },
    tenantSelClear: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selected: null
    }
  },
  computed: {
    options() {
      return this.$store.state.tenant.options
    }
  },
  watch: {
    value(newVal, oldVal) {
      this.selected = newVal
    }
  },
  mounted() {
    if (this.$store.state.user.type !== 'corp') {
      this.$store.dispatch('tenant/setOptions')
    }
  },
  methods: {
    change(value) {
      this.$emit('change', value)
    }
  }

}
</script>
